import React from "react"
import PropTypes from "prop-types"

import MetaButton from "@components/MetaButton/version2"
import ImageHome from "@components/MockableImages"

import { useBreakpoints } from "@hooks/useBreakpoints"

const MiniHero = ({
  title,
  subtitle,
  image,
  hideButtonsOnMobile = false,
  invertedColoursOnMobile = false,
  headerClass = null,
  titleClass = null,
  className,
  contentClassName,
  subheading,
  subheadingClassName,
  overlayImageClassName,
  buttons = [],
  contentTemplate,
  showGradientLayer = false,
  buttonContainerClass = "",
  gradientStyle,
  gradientClassName,
  theme = null,
  subtitleClassName = "",
  imageHomeExtraClass = "",
  imageHeight = null,
}) => {
  const { isMobile, isTablet } = useBreakpoints()

  const headerColor =
    invertedColoursOnMobile && isMobile && !isTablet
      ? "text-white"
      : "text-dblue"

  const invertedStyleHeader =
    invertedColoursOnMobile && isMobile && !isTablet
      ? "bg-dblue"
      : theme && theme === "lblue"
      ? "bg-lblue"
      : ""

  const mb3 = hideButtonsOnMobile && isMobile && !isTablet ? "" : "mb-3"

  const titleClassName = ` 
    font-medium
    text-24 
    font-inter
    leading-[120%]
    
    ${subtitle ? "mb-[8px]" : "mb-[20px]"}
    
    md:text-white

    desk:text-[48px]
    desk:text-bold
    desk:leading-[normal]
    desk:mb-6
    
    ${headerColor}
    ${mb3}`

  return (
    <div className={className}>
      {image && (
        <figure
          className={`relative overflow-hidden md:absolute md:inset-0 ${overlayImageClassName}`}
        >
          <ImageHome
            className={`h-full ${imageHomeExtraClass}`}
            image={image}
            imageHeight={imageHeight}
          />
          {showGradientLayer && (
            <div
              className={`absolute inset-0 ${gradientClassName}`}
              style={
                gradientStyle || {
                  background:
                    "linear-gradient(90deg, rgba(21, 17, 36, 0.80) 45.31%, rgba(21, 17, 36, 0.00) 100%)",
                }
              }
            ></div>
          )}
        </figure>
      )}
      <div className={`relative ${contentClassName} ${invertedStyleHeader}`}>
        <div className={`p-6 md:p-0 ${headerClass}`}>
          {title && (
            <h1 className={`${titleClassName} ${titleClass}`}>{title}</h1>
          )}

          {!title && subheading && (
            <h2 className={`${titleClassName} ${titleClass}`}>{subheading}</h2>
          )}

          {subheading && title && (
            <h2
              className={`  
      text-dblue 
      font-inter 
      font-normal 
      md:text-white 
      ${subheadingClassName}`}
            >
              {subheading}
            </h2>
          )}

          {subtitle && !Array.isArray(subtitle) && (
            <p
              className={` 
              text-bcoral 
                font-inter 
                text-[14px]
                font-normal 
                leading-150% 
                mb-[20px]

                md:text-g70  
                md:leading-140% 
                md:mb-0

                desk:text-[24px]
                desk:leading-[150%]
                ${subtitleClassName}
                `}
            >
              {subtitle}
            </p>
          )}

          {subtitle &&
            Array.isArray(subtitle) &&
            subtitle.map((item, index) => (
              <p
                key={index}
                className={`
                text-bcoral 
                font-inter 
                text-[14px]
                font-normal 
                leading-150% 
                ${index === subtitle.length - 1 ? "mb-[20px]" : "mb-0"}

                md:text-g70 
                md:leading-140% 
                md:mb-0
 
                desk:text-[24px]
                desk:leading-[150%]
                ${item.class}
               `}
              >
                {item.text}
              </p>
            ))}

          {!(hideButtonsOnMobile && isMobile) &&
            buttons &&
            buttons.length > 0 && (
              <>
                <div
                  className={`
                  flex  
                  flex-wrap 
                  gap-3 
                  mt-0 
                  buttonContainerClass 
                  
                  md:mt-[20px]

                  desk:mt-[32px]
                  ${buttonContainerClass}`}
                >
                  {buttons.map((button, index) => (
                    <MetaButton {...button}>{button.text}</MetaButton>
                  ))}
                </div>
              </>
            )}
          {contentTemplate ? contentTemplate : null}
        </div>
      </div>
    </div>
  )
}

MiniHero.propTypes = {
  showGradientLayer: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  cta1text: PropTypes.string,
  cta2text: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  subheading: PropTypes.string,
  subheadingClassName: PropTypes.string,
  overlayImageClassName: PropTypes.string,
  headerClass: PropTypes.string,
  gradientClassName: PropTypes.string,
  cta1Action: PropTypes.func,
  cta2Action: PropTypes.func,
  gradientStyle: PropTypes.object,
}

MiniHero.defaultProps = {
  image: "metal-shavings-background.png",
  className: `
  
    md:min-h-[360px]  
    md:py-16 
    md:px-11 
    md:relative

    desk:min-h-[700px]
    desk:p-[100px]
    `,
  contentClassName: `
    mx-auto 
    max-w-screen-fhd
    `,
  subheadingClassName: `
    text-20 
    leading-120%
    mb-2
  
    desk:text-[36px]  
    desk:leading-[130%]  
    desk:mb-4`,
  headerClass: `
    md:max-w-[332px] 
    
    desk:max-w-[844px]`,
  overlayImageClassName: `
    h-30 
    bg-gradient-to-r 
    from-dblue  
    via-dblue 
    to-dblue

    md:h-full `,
  gradientClassName: "",
}

export default MiniHero
